var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kawaii-dialog',{attrs:{"dialog":_vm.dialog,"hidden-btn":true,"title":"データ使用の同意確認","max-width":"650","btn-message":"調査結果の取り扱いについて、同意する"}},[_c('providing-data-agreement',{on:{"agree":_vm.agree}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }